export default {
  isAdvanced: null,
  async init(): Promise<void> {
    if (this.isAdvanced !== null) {
      return this.isAdvanced;
    }
    try {
      const result = await window.AP.context.getContext();
      this.isAdvanced = result.license.capabilitySet === 'capabilityAdvanced';
    } catch (error) {
      this.isAdvanced = false;
    }
  },
};
